import React from 'react';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { DeleteOutlined } from '@ant-design/icons';
import { EllipsisOutlined } from '@ant-design/icons';
// Ui
import { errorNotification } from 'ui/Notification';
// Styles
import styles from './UploadFilesInput.module.scss';

type UploadScreenshotsProps = {
  value: any;
  onChange: (value: any) => void;
  acceptFileTypes?: string[];
  inputDescription?: string;
  title?: string;
};

const UploadFilesInput = ({
  value,
  onChange,
  title = 'Upload Files',
  acceptFileTypes = ['image/png', 'image/jpeg', 'video/mp4'],
  inputDescription = `Upload a video (max 5GB) in MP4 format, an image in JPEG or PNG
            format or a PDF file.`,
}: UploadScreenshotsProps): JSX.Element => {
  const handleFileRemove = (preview: string) => {
    console.log('preview', preview, value);
    const uploads = value;

    const newUploads: FileWithPreview[] = [];

    uploads?.forEach((item: any) => {
      if ('url' in item) {
        if (item.key !== preview) {
          newUploads.push(item);
        }
      } else {
        if (item.preview !== preview) {
          newUploads.push(item);
        }
      }
    });
    console.log('newUploads', newUploads);
    onChange(newUploads);
    console.log('value', value);
  };
  const onDrop = useCallback(
    (acceptedFiles) => {
      const maxFiles = 10;
      const existingUploads = value;

      if ((existingUploads?.length ?? 0) + acceptedFiles.length <= maxFiles) {
        const filesWithPreview = acceptedFiles.map((item: File) =>
          Object.assign(item, {
            preview: URL.createObjectURL(item),
          })
        );

        onChange([
          ...(existingUploads ? existingUploads : []),
          ...filesWithPreview,
        ]);
      } else {
        errorNotification(
          `${maxFiles} files maximum for upload. You are trying to upload ${acceptedFiles.length} files`
        );
      }
    },
    [value, onChange]
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: acceptFileTypes,
  });

  return (
    <>
      <div className={styles.uploadedFiles}>
        <div className={styles.uploadWrapper} {...getRootProps()}>
          <EllipsisOutlined />
          <input onChange={onChange} {...getInputProps()} />
          <div>
            <h3 className={styles.sectionTitle}>{title}</h3>
            <p className={styles.sectionDescription}>{inputDescription}</p>
          </div>
        </div>

        <div className={styles.uploadedFiles}>
          {value.map((upload: any) => (
            <div
              key={'url' in upload ? upload.key : upload.preview ?? ''}
              className={styles.tag}
            >
              <span>{'url' in upload ? upload.key : upload.name}</span>

              <button
                type="button"
                onClick={() =>
                  handleFileRemove(
                    'url' in upload ? upload.key : upload.preview ?? ''
                  )
                }
                className={styles.deleteButton}
              >
                <DeleteOutlined />
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default UploadFilesInput;
